/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { EnvGroupForSettingsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EnvironmentGroupsQueryVariables = Types.Exact<{
  teamId: Types.Scalars['String'];
}>;


export type EnvironmentGroupsQuery = { __typename?: 'QueryPrediction', environmentGroups: Array<{ __typename?: 'EnvGroupType', id: string, name: string, isRestricted: boolean, usersWithManageAccess: Array<{ __typename?: 'UserType', id: string, username: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type EnvironmentsQueryVariables = Types.Exact<{
  teamId: Types.Scalars['String'];
}>;


export type EnvironmentsQuery = { __typename?: 'QueryPrediction', environments: Array<{ __typename?: 'EnvironmentMappingType', name: string | null | undefined } | null | undefined> | null | undefined };


export const EnvironmentGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EnvironmentGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"environmentGroups"},"name":{"kind":"Name","value":"env_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnvGroupForSettingsFragment"}}]}}]}},...EnvGroupForSettingsFragmentDoc.definitions]} as unknown as DocumentNode<EnvironmentGroupsQuery, EnvironmentGroupsQueryVariables>;
export const EnvironmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Environments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"environments"},"name":{"kind":"Name","value":"all_environments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"environment_name"}}]}}]}}]} as unknown as DocumentNode<EnvironmentsQuery, EnvironmentsQueryVariables>;
export const namedOperations = {
  Query: {
    EnvironmentGroups: 'EnvironmentGroups',
    Environments: 'Environments'
  }
}

/**
 * __useEnvironmentGroupsQuery__
 *
 * To run a query within a React component, call `useEnvironmentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentGroupsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useEnvironmentGroupsQuery(baseOptions: Apollo.QueryHookOptions<EnvironmentGroupsQuery, EnvironmentGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentGroupsQuery, EnvironmentGroupsQueryVariables>(EnvironmentGroupsDocument, options);
      }
export function useEnvironmentGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentGroupsQuery, EnvironmentGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentGroupsQuery, EnvironmentGroupsQueryVariables>(EnvironmentGroupsDocument, options);
        }
export type EnvironmentGroupsQueryHookResult = ReturnType<typeof useEnvironmentGroupsQuery>;
export type EnvironmentGroupsLazyQueryHookResult = ReturnType<typeof useEnvironmentGroupsLazyQuery>;
export type EnvironmentGroupsQueryResult = Apollo.QueryResult<EnvironmentGroupsQuery, EnvironmentGroupsQueryVariables>;
export function refetchEnvironmentGroupsQuery(variables: EnvironmentGroupsQueryVariables) {
      return { query: EnvironmentGroupsDocument, variables: variables }
    }
/**
 * __useEnvironmentsQuery__
 *
 * To run a query within a React component, call `useEnvironmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useEnvironmentsQuery(baseOptions: Apollo.QueryHookOptions<EnvironmentsQuery, EnvironmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentsQuery, EnvironmentsQueryVariables>(EnvironmentsDocument, options);
      }
export function useEnvironmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentsQuery, EnvironmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentsQuery, EnvironmentsQueryVariables>(EnvironmentsDocument, options);
        }
export type EnvironmentsQueryHookResult = ReturnType<typeof useEnvironmentsQuery>;
export type EnvironmentsLazyQueryHookResult = ReturnType<typeof useEnvironmentsLazyQuery>;
export type EnvironmentsQueryResult = Apollo.QueryResult<EnvironmentsQuery, EnvironmentsQueryVariables>;
export function refetchEnvironmentsQuery(variables: EnvironmentsQueryVariables) {
      return { query: EnvironmentsDocument, variables: variables }
    }